import CtrlEquipesPage from '@/modules/app/ctrl-equipes/pages/CtrlEquipesPage.vue';
import EquipeUsuarioAssociacaoPage from '@/modules/app/ctrl-equipes/pages/EquipeUsuarioAssociacaoPage.vue';
import EquipeTarefaAssociacaoPage from '@/modules/app/ctrl-equipes/pages/EquipeTarefaAssociacaoPage.vue';

const routes = [{
    path: 'ctrl-equipes',
    name: 'ctrl-equipes',
    component: CtrlEquipesPage
}, {
    path: 'ctrl-equipes/:equipe/usuarios',
    name: 'equipe-usuarios',
    component: EquipeUsuarioAssociacaoPage
}, {
    path: 'ctrl-equipes/:equipe/tarefas',
    name: 'equipe-tarefas',
    component: EquipeTarefaAssociacaoPage
}];

export default routes;